"use strict";

(function () {
    const dashboardItemTypes = {};

    EWS.BC_DashboardItemTypesManager = function () {

    };

    EWS.BC_DashboardItemTypesManager.prototype.add = function (type, itemType) {
        if (!dashboardItemTypes[type]) {
            const defaultItemType = {
                showEditButton: false,
                enableFilters: false,
                itemFields: [],
                addItem(createNewItemCallback) {
                    // createNewItemCallback has two parameters, title and itemfields, then return the new item
                    createNewItemCallback();
                },
                editItem() {

                },
                onLoaded() {

                },
                createViewButtons() {

                },
                createEditButtons() {

                },
                getDashboardDocuments() {
                    // Type
                    // GlobalDocumentID
                }
            };

            itemType = Object.assign(defaultItemType, itemType);

            dashboardItemTypes[type] = itemType;
        }
    };

    EWS.BC_DashboardItemTypesManager.prototype.hasItemType = function (type) {
        return dashboardItemTypes[type] !== undefined;
    };

    EWS.BC_DashboardItemTypesManager.prototype.addItem = function (type, createNewItemCallback) {
        dashboardItemTypes[type].addItem(createNewItemCallback);
    };

    EWS.BC_DashboardItemTypesManager.prototype.editItem = function (type, title, itemFields, dashboardItem, editItemCallback) {
        dashboardItemTypes[type].editItem(title, itemFields, dashboardItem, editItemCallback);
    };

    EWS.BC_DashboardItemTypesManager.prototype.showEditButton = function (type) {
        return dashboardItemTypes[type].showEditButton;
    };

    EWS.BC_DashboardItemTypesManager.prototype.enableFilters = function (type) {
        return dashboardItemTypes[type].enableFilters;
    };

    EWS.BC_DashboardItemTypesManager.prototype.getItemFields = function (type) {
        if (this.hasItemType(type)) {
            return dashboardItemTypes[type].itemFields;
        }

        return [];
    };

    EWS.BC_DashboardItemTypesManager.prototype.getDashboardDocuments = function (type, dashboardItem, itemFields) {
        if (this.hasItemType(type)) {
            return dashboardItemTypes[type].getDashboardDocuments(dashboardItem, itemFields);
        }

        return [];
    };

    EWS.BC_DashboardItemTypesManager.prototype.onLoaded = function (type, dashboardItem, itemFields, isEdit) {
        if (this.hasItemType(type)) {
            return dashboardItemTypes[type].onLoaded(dashboardItem, itemFields, isEdit);
        }

        return [];
    };

    EWS.BC_DashboardItemTypesManager.prototype.createViewButtons = function (type, dashboardItem, itemFields) {
        let buttons = "";
        const showPlus = type !== "Spacer" && (!dashboardItem.classList.contains("hide-border") || dashboardItem.classList.contains("dashboard-item"));

        let plusArr = dashboardItem.querySelectorAll(".edit-control [action='Plus']");

        for (let i = 0; i < plusArr.length; i++) {
            const plus = plusArr[i];

            plus.parentElement.removeChild(plus);
        }

        if (!dashboardItem.classList.contains("dashboard-item") || dashboardItem.classList.contains("show-expand")) {
            if (dashboardItem.getAttribute("Collapsed") === "False") {
                buttons += `  <a class="widget-action item-action ews-icon-minus-square-o ${showPlus ? "" : "hidden"}" action="Plus" Title=""></a>`;
            } else {
                const widgetSizey = parseInt(dashboardItem["data-sizey"] || dashboardItem.getAttribute("data-sizey"), 10);
                const hideElementArr = dashboardItem.querySelectorAll(".content, .ContentFooter");

                for (let i = 0; i < hideElementArr.length; i++) {
                    const hideElement = hideElementArr[i];
                    hideElement.style.display = "none";
                }

                dashboardItem["data-sizey"] = widgetSizey;

                if (EWS.Dashboard && EWS.Dashboard.resize_widget) {
                    EWS.Dashboard.resize_widget($(dashboardItem), dashboardItem.getAttribute("data-sizex"), 1);
                } else {
                    dashboardItem.style.minHeight = "36px";
                }

                buttons += `  <a class="widget-action item-action ews-icon-plus-square-o ${showPlus ? "" : "hidden"}" action="Plus" Title=""></a>`;
            }
        }

        if (buttons) {
            dashboardItem.querySelector(".edit-control").appendChild(EC_Fmt.HtmlStrToElement(buttons));
        }

        plusArr = dashboardItem.querySelectorAll(".edit-control [action='Plus']");

        const plusFunction = function () {
            const trigger = this;
            const isExpand = trigger.classList.contains("ews-icon-minus-square-o");
            const isWaitRequest = dashboardItem.isWaitRequest;

            if (isExpand) {
                if (!isWaitRequest) {
                    dashboardItem.isWaitRequest = true;
                    const mySetDashboardItemStatusRequest = new ECP.EC_Request("Dashboard_SetDashboardItemStatus");

                    mySetDashboardItemStatusRequest.SetReturnType(ECP.EC_ReturnType.Text);
                    mySetDashboardItemStatusRequest.AddRequestVariable("DashboardID", Settings.DashboardID);
                    mySetDashboardItemStatusRequest.AddRequestVariable("DashboardItemID", dashboardItem.getAttribute("id"));
                    mySetDashboardItemStatusRequest.AddRequestVariable("Collapsed", "True");

                    mySetDashboardItemStatusRequest.Submit().then(() => {
                        const widgetSizey = parseInt(dashboardItem.getAttribute("data-sizey"), 10);
                        const hideElementArr = dashboardItem.querySelectorAll(".content, .ContentFooter");

                        for (let i = 0; i < hideElementArr.length; i++) {
                            const hideElement = hideElementArr[i];
                            hideElement.style.display = "none";
                        }

                        dashboardItem["data-sizey"] = widgetSizey;

                        if (!EC_Fmt.isMobile && EWS.Dashboard && EWS.Dashboard.resize_widget) {
                            EWS.Dashboard.resize_widget($(dashboardItem), dashboardItem.getAttribute("data-sizex"), 1);
                        } else {
                            dashboardItem.style.minHeight = "36px";
                        }

                        trigger.classList.remove("ews-icon-minus-square-o");
                        trigger.classList.add("ews-icon-plus-square-o");

                        const ulArr = document.querySelectorAll("#Dashboard > ul");

                        for (let i = 0; i < ulArr.length; i++) {
                            const ul = ulArr[i];
                            ul.style.width = "100%";
                        }

                        dashboardItem.setAttribute("Collapsed", "True");

                        dashboardItem.isWaitRequest = false;
                    });
                }
            } else if (!isWaitRequest) {
                dashboardItem.isWaitRequest = true;

                const mySetDashboardItemStatusRequest = new ECP.EC_Request("Dashboard_SetDashboardItemStatus");

                mySetDashboardItemStatusRequest.SetReturnType(ECP.EC_ReturnType.Text);
                mySetDashboardItemStatusRequest.AddRequestVariable("DashboardID", Settings.DashboardID);
                mySetDashboardItemStatusRequest.AddRequestVariable("DashboardItemID", dashboardItem.getAttribute("id"));
                mySetDashboardItemStatusRequest.AddRequestVariable("Collapsed", "False");

                mySetDashboardItemStatusRequest.Submit().then(() => {
                    const hideElementArr = dashboardItem.querySelectorAll(".content, .ContentFooter");

                    for (let i = 0; i < hideElementArr.length; i++) {
                        const hideElement = hideElementArr[i];
                        hideElement.style.display = "block";
                    }

                    if (!EC_Fmt.isMobile && EWS.Dashboard && EWS.Dashboard.resize_widget) {
                        EWS.Dashboard.resize_widget($(dashboardItem), dashboardItem.getAttribute("data-sizex"), dashboardItem["data-sizey"]);
                    }

                    trigger.classList.remove("ews-icon-plus-square-o");
                    trigger.classList.add("ews-icon-minus-square-o");

                    const ulArr = document.querySelectorAll("#Dashboard > ul");

                    for (let i = 0; i < ulArr.length; i++) {
                        const ul = ulArr[i];
                        ul.style.width = "100%";
                    }

                    dashboardItem.setAttribute("Collapsed", "False");

                    // Task 663122: Fusion Graph on iOS safari: If Graph widget starts collapsed when I click + to expand it formatting is messed up
                    if (dashboardItem["item-loaded"] !== "True" && (dashboardItem.getAttribute("item-type") === "ReportGraph" || dashboardItem.querySelectorAll("iframe").length > 0)) {
                        // need to wait for expand animation
                        setTimeout(() => {
                            LoadDashboardItem(dashboardItem, dashboardItem.getAttribute("url"));
                            dashboardItem["item-loaded"] = "True";
                        }, 200);
                    }

                    dashboardItem.isWaitRequest = false;
                });
            }
        };

        for (let i = 0; i < plusArr.length; i++) {
            const plus = plusArr[i];

            plus.addEventListener("click", plusFunction);
        }

        if (this.hasItemType(type)) {
            const viewButtons = dashboardItemTypes[type].createViewButtons(dashboardItem, itemFields);

            if (viewButtons) {
                const editControl = dashboardItem.querySelector(".edit-control");

                if (viewButtons.length >= 0) {
                    for (let i = 0; i < viewButtons.length; i++) {
                        const viewButton = viewButtons[i];

                        editControl.appendChild(viewButton);
                    }
                } else {
                    editControl.appendChild(viewButtons);
                }
            }
        }
    };

    EWS.BC_DashboardItemTypesManager.prototype.createEditButtons = function (type, dashboardItem, itemFields) {
        let buttons = "";

        if (this.hasItemType(type)) {
            buttons = dashboardItemTypes[type].createEditButtons(dashboardItem, itemFields);
        }

        return buttons;
    };

    EWS.DashboardItemTypesManager = new EWS.BC_DashboardItemTypesManager();
}());
